import { defineComponent, useCssVars, ref, computed, watch } from "vue";
import ForwardBackwardButton from "./component-library15.mjs";
import LinkButton from "./component-library3.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "carousel-navigation",
  props: {
    pages: { default: void 0 },
    ariaLabel: { default: "Pagination" },
    infinity: { type: Boolean },
    labelPrev: { default: "Vorherige Seite" },
    labelNext: { default: "Nächste Seite" },
    hidePages: { type: Boolean },
    hidePagesMobile: { type: Boolean },
    primary: { type: Boolean },
    secondary: { type: Boolean },
    buttonLabelFirst: { default: "Gehe zur ersten Seite" },
    buttonLabelLast: { default: "Gehe zur letzten Seite" },
    buttonLabel: { default: "Gehe zu Seite %d" },
    doNotScrollIntoView: { type: Boolean }
  },
  emits: ["update"],
  setup(__props, { emit: emits }) {
    const props = __props;
    useCssVars((_vm, _setup) => ({
      "2a972bc2": _setup.justifyContainer,
      "75a4498c": _setup.paginationDisplay
    }));
    const carouselNavigationElement = ref(null);
    const ariaLabelForPageNumber = (pages, page) => {
      if (page.number === 0) {
        return props.buttonLabelFirst;
      }
      if (page.number === pages.length - 1) {
        return props.buttonLabelLast;
      }
      return props.buttonLabel.replace("%d", (page.number + 1).toString());
    };
    const activePage = computed(() => {
      var _a;
      return (_a = props.pages) == null ? void 0 : _a.find((page) => page.active);
    });
    const paginationDisplay = computed(() => props.hidePagesMobile ? "none" : "inline-flex");
    const justifyContainer = computed(() => props.hidePagesMobile ? "flex-end" : "center");
    const clickPrev = () => {
      var _a;
      if (!activePage.value)
        return;
      if (activePage.value.number - 1 < 0) {
        emits("update", ((_a = props.pages) == null ? void 0 : _a.length) ? props.pages.length - 1 : 0);
      } else {
        emits("update", activePage.value.number - 1);
      }
    };
    const clickNext = () => {
      var _a;
      if (!activePage.value)
        return;
      if (activePage.value.number + 1 > (((_a = props.pages) == null ? void 0 : _a.length) || 0) - 1) {
        emits("update", 0);
      } else {
        emits("update", activePage.value.number + 1);
      }
    };
    watch(
      () => props.pages,
      () => {
        if (props.doNotScrollIntoView)
          return;
        setTimeout(() => {
          var _a;
          if (!carouselNavigationElement.value)
            return;
          (_a = carouselNavigationElement.value.querySelector(".carousel-navigation__link--active")) == null ? void 0 : _a.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
        }, 10);
      },
      { deep: true }
    );
    return { __sfc: true, props, carouselNavigationElement, emits, ariaLabelForPageNumber, activePage, paginationDisplay, justifyContainer, clickPrev, clickNext, ForwardBackwardButton, LinkButton };
  }
});
export {
  _sfc_main as default
};
